var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"px-0"},[_c('div',{staticClass:"subtitle-1",attrs:{"data-test":"subtitle"}},[_vm._t("subtitle")],2),_c('v-spacer'),_c('v-toolbar-items',{staticClass:"align-center",attrs:{"data-test":"links"}},[_vm._t("links")],2),_c('v-spacer'),_c('div',{attrs:{"data-test":"social"}},[_vm._t("social")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }